import { render } from "./BuildImages.vue?vue&type=template&id=7a50d286"
const script = {}

import "./BuildImages.vue?vue&type=style&index=0&id=7a50d286&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__